
export class SoPackingStatusRequest{
    unitId?:number; 
    saleOrderId?:number[];
    itemSubCategoryId?:number;
    fromDate?:any;
    toDate?:any;
    itemNameId?:number;
    packingSubCategory?:string;
}